export const CURRENCY = "$";
export var recordsLimit = 10;
export var recordsLimit50 = 50;
export const googleMapApiKey = "";

export const falsyArray = [
  null,
  undefined,
  "",
  0,
  false,
  NaN,
  "null",
  "undefined",
  "false",
  "0",
  "NaN",
];
export const fileTypesAllowed = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "video/mp4",
  "video/mpeg",
  "video/quicktime",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
export const videoFileTypes = ["mp4", "mpeg", "quicktime"];

export const allowedFileTypes = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "image/*": [".png", ".jpeg", ".jpg"],
};
export const allowedDocTypes = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
};
export const allowedImageTypes = {
  "image/*": [".png", ".jpeg", ".jpg", ".jfif", ".webp"],
};

export const STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

// permission route
export const permissionRoute = {
  "/cms": "cms-management",
  "/role-management": "role-management",
  "/orders": "order-management",
  "/user-management": "user-management",
  "/analytics-report": "report-management",
  "/staff-management": "staff-management",
  "/products": "product-management",
  "/promotion": "promotion-code-management",
  "/voucher": "voucher-management",
  "/promotion-vouchers": ["promotion-code-management", "voucher-management"],
};
export const notProtectedRoute = ["/login", "/", "/settings", "/notifications"];

export const BOOKING_STATUS = {
  PENDING: "pending",
  CONFIRMED: "confirmed",
  COMPLETED: "completed",
  IN_PROGRESS: "in-progress",
  CANCELLED: "cancelled",
};
export const Roles = {
  ADMIN: "admin",
  ENTREPRENEUR: "entrepreneur",
  INVESTOR: "investor",
};

export const USER_STATUS = {
  PENDING: "pending",
  ACTIVE: "active",
  REJECTED: "rejected",
  SUSPENDED: "suspended",
};

export const PROJECT_STATUS = {
  ACTIVE: "active",
  FUNDED: "funded",
  NEGOTIATING: "negotiating",
  PENDING: "pending",
  REVESION: "revision",
  REJECTED: "rejected",
};
export const PROJECT_TYPE = {
  WADISEED: "seed",
  WADIVAULT: "vault",
  WADISCALE: "scale",
};
export const PROJECT_TYPE_NAME = {
  [PROJECT_TYPE.WADISEED]: "WadiSeed",
  [PROJECT_TYPE.WADIVAULT]: "WadiVault",
  [PROJECT_TYPE.WADISCALE]: "WadiScale",
};

export const PROJECT_STATUS_NAME = {
  [PROJECT_STATUS.ACTIVE]: "Active",
  [PROJECT_STATUS.PENDING]: "Pending",
  [PROJECT_STATUS.REVESION]: "Revision",
  [PROJECT_STATUS.REJECTED]: "Rejected",
  [PROJECT_STATUS.FUNDED]: "Funded",
  [PROJECT_STATUS.NEGOTIATING]: "Negotiating",
};

export const DEAL_STATUS = {
  ACTIVE: "active", // Active deal negotiations or approved
  PROPOSED: "proposed", // Deal proposed
  // REQUESTED: "requested", // Investor requested deal
  GRANTED: "granted", // Deal successfully closed
  CANCELLED: "cancelled", // Deal cancelled
};
export const DEAL_STATUS_NAME = {
  [DEAL_STATUS.ACTIVE]: "Active",
  [DEAL_STATUS.PROPOSED]: "Concluded",
  [DEAL_STATUS.GRANTED]: "Granted",
  [DEAL_STATUS.CANCELLED]: "Cancelled",
};
